
    export default 
    {
    "select_platform": {
        "title": "¿A qué plataforma quieres acceder?"
    }
}